import React from 'react';
import clsx from 'clsx';

// eslint-disable-next-line react/display-name
const BackdropUnstyled = React.forwardRef((props: any, ref) => {
  const { className, ownerState, ...other } = props;
  return <div className={clsx('c-modal', className)} ref={ref} {...other} />;
});

export default BackdropUnstyled;
